/**
 * ORIGINAL GOAT THEME CHANGE
 * Date: 2026-08-01
 * Reason: Preserve the Priority Access Klaviyo form trigger and tracking
 * after Xtra dynamically replaces product markup during variant changes.
 * BEGIN CHANGE
 */

(function initializePriorityAccessTrigger() {
  'use strict';

  const BUTTON_SELECTOR = '[data-priority-access-trigger]';
  const KLAVIYO_FORM_ID = 'VWWTyG';

  /*
   * Prevent duplicate listeners if og-scripts.js is accidentally loaded
   * more than once.
   */
  if (window.originalGoatPriorityAccessInitialized) {
    return;
  }

  window.originalGoatPriorityAccessInitialized = true;

  /*
   * Listen on document rather than attaching directly to the button.
   * The document remains in place when Xtra replaces product markup after
   * a variant change.
   */
  document.addEventListener('click', function handlePriorityAccessClick(event) {
    if (!(event.target instanceof Element)) {
      return;
    }

    const button = event.target.closest(BUTTON_SELECTOR);

    if (!button) {
      return;
    }

    /*
     * Do not run the trigger when the button has intentionally been disabled.
     */
    if (
      button.disabled ||
      button.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    event.preventDefault();

    /*
     * Open the Klaviyo Priority Access form.
     *
     * Using the queue allows the command to be registered even when
     * Klaviyo.js has not finished loading at the moment of the click.
     */
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push([
      'openForm',
      KLAVIYO_FORM_ID
    ]);

    /*
     * Track the Priority Access button click in Klaviyo.
     *
     * The queue-based format is safer than calling klaviyo.track() directly
     * because the Klaviyo library might still be loading.
     */
    window.klaviyo = window.klaviyo || [];
    window.klaviyo.push([
      'track',
      'Joined Waitlist',
      {
        Page: button.dataset.page || 'product-page',
        ProductName: button.dataset.productTitle || '',
        ProductHandle: button.dataset.productHandle || '',
        VariantID: getCurrentVariantId(button),
        ProductionState: button.dataset.productionState || '',
        ProductURL: window.location.href
      }
    ]);
  });

  /**
   * Return the currently selected variant ID.
   *
   * First uses the button's data attribute, which Xtra should refresh when
   * replacing the product markup. The product form input is used as a
   * fallback when available.
   *
   * @param {HTMLElement} button - Priority Access button that was clicked.
   * @returns {string} Current Shopify variant ID.
   */
  function getCurrentVariantId(button) {
    const productContainer =
      button.closest('product-form') ||
      button.closest('[data-product-form]') ||
      button.closest('.product-form') ||
      button.closest('form[action*="/cart/add"]') ||
      button.parentElement;

    const variantInput = productContainer
      ? productContainer.querySelector('[name="id"]')
      : null;

    return variantInput?.value || button.dataset.variantId || '';
  }
})();

/**
 * END CHANGE
 */

